// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./ad_scroll_back.png");
var dir = previousRequest.replace("ad_scroll_back.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "ad_scroll_back.png",
	name: "ad_scroll_back",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/ad_scroll_back.png
// module id = 972
// module chunks = 4